// src/components/Hero.js
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import '../styles/artists.scss'


const artistsData = [
  {
    id: 1,
    image: '/images/About/HQMemphis.png',
    link: '/artists/Simone',
    title: 'SIMONE BERNINI',
    description: '',
  },
  {
    id: 2,
    image: '/images/Artists/PumPum.jpg',
    link: 'https://open.spotify.com/intl-it/track/69eQHdoTenhKE9dJYk4Ss5?si=424add993b6042f3',
    title: '"PUM PUM" BY GEORGIA MOS OFFICIAL COVER',
  },
  {
    id: 3,
    image: '/images/Artists/DidiFuckboy.jpg',
    link: '/artists/Didi',
    title: 'DIDI',
    description: '',
  },

{
    id: 4,
    image: '/images/Artists/LowrahStamina.jpeg',
    link: 'https://www.youtube.com/watch?v=hd8QA0LcR8I',
    title: '"STAMINA" OFFICIAL VIDEOCLIP LOWRAH',
    description: 'Now single "Stamina" out on Youtube',
  },

  {
    id: 5,
    image: '/images/Artists/Settembre.png',
    link: 'https://www.youtube.com/watch?v=txuIcQsOb1A',
    title: '"ORO ORO" OFFICIAL COVER ANDREA SETTEMBRE',
    description: 'Now single "ORO ORO" out on Spotify',
  },
  {
    id: 6,
    image: '/images/Artists/wax.jpeg',
    title: 'WAX',
    description: 'Editorial project x Wax',
  },
  {
    id: 7,
    image: '/images/Artists/Mos.jpeg',
    title: '"CONFETTI" OFFICIAL VIDEOCLIP GEORGIA MOS',
    link: 'https://www.youtube.com/watch?v=2NR3Q4J6SdI&ab_channel=GeorgiaMos',
    description: 'Official Videoclip out on Youtube and Spotify',
  },
  {
    id: 8,
    image: '/images/Artists/Desperado.jpg',
    title: '"DESPERADO" OFFICIAL VIDEOCLIP CALILION, TURI MONCADA, VALENTINO',
    link: 'https://www.youtube.com/watch?v=S1xAHtCmZKs&ab_channel=GORILLASAUCETV',
    description: 'Official Videoclip out on Youtube and Spotify',
  }
];
function Artists() {
  return (
    <section className="artists">
      <Container fluid>
        <Row className="g-4 justify-content-center"> {/* Centratura e spaziatura */}
          {artistsData.map((item) => (
            <Col xs={12} sm={6} md={4} lg={3} key={item.id}>
              <div className="artists__card">
                <a href={item.link} className="artists__card-link">
                  <div className="artists__card-image">
                    <Image src={item.image} alt={item.title} fluid className="artists__card-img" />
                  </div>
                  <h3 className="artists__card-title" style={item.id === 1 || item.id ===6 || item.id ===3 ? { textAlign: 'center' } : {}}>{item.title}</h3>
                  <p className="artists__card-description"style={item.id === 1 || item.id ===6 || item.id ===3 ? { textAlign: 'center' } : {}} >{item.description}</p>
                </a>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Artists;
